module.exports = __webpack_public_path__ + "img/generic-rating-sorting-desc.b53db52e.png";